// @ts-ignore
import SlimApi from '@/util/slimapi'
// @ts-ignore
import SlimApis from '@/util/slimapis'
// @ts-ignore
import $store from '@/store/index'
// @ts-ignore
import Data from '@/util/data'
// @ts-ignore
import util from '@/util/util'

export default {
  getOpenOrders () {
    SlimApis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('open_orders', {
      params: {
        token: $store.state.sys.token,
        etid: $store.state.sys.tradeExchange.Id
      }
    }).then((response: any) => {
      if (response.data !== null) {
        if (!response.data.err) {
          // @ts-ignore
          $store.state.openOrdersModal.openOrders = response.data
          // @ts-ignore
          $store.state.openOrdersModal.show = true
        } else {
          Data.vm.$Notice.error({
            title: Data.vm.$text.tr('Ошибка'),
            desc: util.returnTextForErr(response.data.err),
            duration: 15
          })
        }
      } else {
        Data.vm.$Notice.info({
          title: Data.vm.$text.tr('нет ордеров'),
          duration: 1
        })
      }
    }).catch((error: string) => {
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: util.returnTextForErr(error),
        duration: 15
      })
      console.log(error)
    })
  }
}
